import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { formatarDataTexto } from 'src/app/utils/query-params.utils';

@Injectable({
  providedIn: 'root'
})
export class HistoricoComprasUsuarioService {

  constructor(private readonly http: HttpClient) { }

  getAllHistoricoCompras(idUsuario: number, dataInicial: string, dataFinal: string, pagina: any, tamanho: any) {
    const url = `/apiconnect/importation/report/historic-orders/${idUsuario}/users?${formatarDataTexto(dataFinal, 'dataFim')}${formatarDataTexto(dataInicial, '&dataInicio')}&pagina=${pagina}&registros=${tamanho}`;
    return this.http.get(url);
  }

  exportarRelatorio(idUsuario: number, dataInicial: string, dataFinal: string) {
    return this.http.get(
      `/apiconnect/importation/report/user-historic-order/${idUsuario}/users?${formatarDataTexto(dataFinal, 'dataFim')}${formatarDataTexto(dataInicial, '&dataInicio')}`,
      { observe: 'response', responseType: 'blob' as 'json' }
    );
  }
}
